/* BrComfy size finder.
   Estimates body chest (tops) or hip (bottoms) from height/weight/build and/or
   the size the shopper wears in another brand, then picks the size whose REAL
   garment measurement (from the product's brc.size_chart metafield) gives the
   right amount of room for the fit they like. Remembers the profile so every
   product page can show "Your size: M" straight away. */
(function () {
  'use strict';
  var KEY = 'brc-fit';

  // Typical body chest / hip (cm) behind each letter size.
  var STD = {
    m: { top: { XS: 88, S: 94, M: 100, L: 106, XL: 112, '2XL': 118, '3XL': 124 }, bottom: { XS: 90, S: 96, M: 102, L: 108, XL: 114, '2XL': 120, '3XL': 126 } },
    w: { top: { XS: 82, S: 87, M: 92, L: 98, XL: 104, '2XL': 110, '3XL': 116 }, bottom: { XS: 90, S: 95, M: 100, L: 106, XL: 112, '2XL': 118, '3XL': 124 } }
  };
  // How a brand's size compares with the standard. Negative = runs small
  // (a Zara L sits on a smaller body), positive = runs big / very oversized.
  var BRAND = { nike: 0, adidas: 0, zara: -4, hm: 0, uniqlo: -3, asos: 0, primark: 2, represent: 2, nude: 0, corteiz: 0, essentials: 6, trapstar: 0, gymshark: -2, ralph: 0, other: 0 };
  // Target room (garment circumference minus body) by product cut and preference.
  var EASE = {
    top: { loose: { fitted: 14, regular: 22, oversized: 30 }, regular: { fitted: 6, regular: 10, oversized: 20 } },
    bottom: { loose: { fitted: 5, regular: 9, oversized: 15 }, regular: { fitted: 3, regular: 7, oversized: 13 } }
  };

  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function save(p) { try { localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) {} }
  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : 0; }
  function norm(z) { return String(z).toUpperCase().replace('XXXL', '3XL').replace('XXL', '2XL'); }

  function estimate(p, kind) {
    var est = [], g = p.gender || 'm';
    if (p.h > 120 && p.w > 30) {
      var b = p.build === 'slim' ? -3 : p.build === 'broad' ? 4 : 0;
      if (kind === 'top') est.push(0.48 * p.w + 0.18 * p.h + 30 + b + (g === 'w' ? -2 : 0));
      else est.push(0.5 * p.w + 0.2 * p.h + 29 + b + (g === 'w' ? 5 : 0));
    }
    if (p.brand && p.bsize) {
      var base = STD[g][kind][norm(p.bsize)];
      if (base) {
        var off = BRAND[p.brand] || 0;
        var fitAdj = p.bfit === 'tight' ? 3 : p.bfit === 'loose' ? -3 : 0;
        est.push(base + off + fitAdj);
      }
    }
    if (!est.length) return null;
    return est.reduce(function (a, c) { return a + c; }, 0) / est.length;
  }

  function recommend(data, p) {
    var kind = data.kind, body = estimate(p, kind);
    if (body == null) return null;
    var dim = kind === 'top' ? 'Chest' : 'Hip';
    var row = data.chart && (data.chart[dim] || data.chart[dim.toLowerCase()]);
    // judge the real cut from the measurements, not the label
    var cut = /oversiz|loose|boxy/i.test(data.fit) ? 'loose' : 'regular';
    if (row) {
      var keys = Object.keys(row), mid = row.M != null ? row.M : row[keys[Math.floor(keys.length / 2)]];
      if (typeof mid === 'number') cut = (mid * 2 - (kind === 'top' ? 100 : 102)) >= (kind === 'top' ? 17 : 9) ? 'loose' : 'regular';
    }
    var target = body + EASE[kind][cut][p.pref || 'regular'];
    var sizes = data.sizes.slice();
    var scored = [];
    if (row) {
      // Designed-oversized pieces: recommend the size that gives the look the garment was cut for
      // (true to size), using the garment's own grading. "Oversized" goes about one size up, "fitted" one down.
      if (cut === 'loose') {
        var mKey = row.M != null ? 'M' : Object.keys(row)[Math.floor(Object.keys(row).length / 2)];
        var stdM = STD[p.gender || 'm'][kind].M;
        var shiftPref = p.pref === 'oversized' ? 6 : p.pref === 'fitted' ? -5 : 0;
        target = body + (row[mKey] * 2 - stdM) + shiftPref;
      }
      var lenRow = data.chart.Length || data.chart.length, slv = data.chart['Sleeve length'], sh = data.chart.Shoulder;
      sizes.forEach(function (z) {
        var flat = row[z] != null ? row[z] : row[norm(z)];
        if (flat == null) return;
        var d = flat * 2 - target, pen = 0;
        // too short for a tall customer? (body length, and arm reach on long sleeves)
        if (p.h > 120 && lenRow && lenRow[z] != null) {
          var needLen = kind === 'top' ? 0.38 * p.h : (lenRow[z] > 80 ? 0.55 * p.h : 0);
          if (lenRow[z] < needLen) pen += (needLen - lenRow[z]) * 1.5;
          if (kind === 'top' && slv && slv[z] > 40 && sh && sh[z] != null) {
            var reach = sh[z] / 2 + slv[z], needReach = 0.48 * p.h;
            if (reach < needReach) pen += (needReach - reach) * 1.5;
          }
        }
        scored.push({ size: z, garment: flat * 2, diff: Math.abs(d) + (d > 0 ? 0.5 : 0) + pen, dir: d });
      });
    }
    if (!scored.length) {
      // no chart: fall back to standard sizing, shifted by preference
      var std = STD[p.gender || 'm'][kind], shift = p.pref === 'oversized' ? 6 : p.pref === 'fitted' ? -3 : 0;
      sizes.forEach(function (z) { var v = std[norm(z)]; if (v) scored.push({ size: z, garment: null, diff: Math.abs(v - body - shift), dir: v - body - shift }); });
    }
    if (!scored.length) return null;
    scored.sort(function (a, b) { return a.diff - b.diff; });
    var best = scored[0], alt = scored[1];
    return { body: body, target: target, best: best, alt: alt, dim: dim, kind: kind, cut: cut };
  }

  function setPressed(group, v) { group.querySelectorAll('[data-v],[data-u]').forEach(function (b) { b.setAttribute('aria-pressed', String((b.dataset.v || b.dataset.u) === v)); }); }

  function selectSize(root, size) {
    var scope = root.closest('.shopify-section') || document;
    var inputs = Array.prototype.slice.call(scope.querySelectorAll('input[type="radio"]')).filter(function (i) { return /size/i.test(i.dataset.optionName || i.name || ''); });
    var hit = inputs.find(function (i) { return norm(i.value) === norm(size); });
    if (hit) {
      hit.click();
      var label = hit.closest('label'); if (label) label.scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (window.BRC && BRC.toast) BRC.toast('Size ' + size + ' selected');
      return true;
    }
    return false;
  }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var data; try { data = JSON.parse(root.querySelector('[data-brc-sa-data]').textContent); } catch (e) { return; }
    var drawer = root.querySelector('[data-brc-sa-drawer]');
    document.body.appendChild(drawer); // escape any transformed ancestor
    var prof = load();
    var st = Object.assign({ hUnit: 'cm', wUnit: 'kg', gender: 'm', build: 'avg', pref: 'regular', brand: '', bsize: '', bfit: 'right' }, prof.profile || {});
    if (data.gender) st.gender = data.gender; // this page's sizing (e.g. womenswear)
    var last = null;

    var q = function (sel) { return drawer.querySelector(sel); };
    var h1 = q('[data-brc-h1]'), h2 = q('[data-brc-h2]'), w1 = q('[data-brc-w1]'), w2 = q('[data-brc-w2]');

    // ---------- prefill ----------
    function applyUnits() {
      setPressed(q('[data-brc-unit="h"]'), st.hUnit); setPressed(q('[data-brc-unit="w"]'), st.wUnit);
      h2.hidden = st.hUnit !== 'ft'; h1.placeholder = st.hUnit === 'ft' ? 'ft' : '178';
      w2.hidden = st.wUnit !== 'st'; w1.placeholder = st.wUnit === 'kg' ? '72' : st.wUnit === 'st' ? 'st' : 'lb';
    }
    function fillFromProfile() {
      if (st.hCm) { if (st.hUnit === 'ft') { var inch = st.hCm / 2.54; h1.value = Math.floor(inch / 12); h2.value = Math.round(inch % 12); } else h1.value = Math.round(st.hCm); }
      if (st.wKg) { if (st.wUnit === 'st') { var lb = st.wKg / 0.453592; w1.value = Math.floor(lb / 14); w2.value = Math.round(lb % 14); } else if (st.wUnit === 'lb') w1.value = Math.round(st.wKg / 0.453592); else w1.value = Math.round(st.wKg); }
      ['gender', 'build', 'pref', 'bsize', 'bfit'].forEach(function (k) { var g = q('[data-brc-opt="' + k + '"]'); if (g && st[k]) setPressed(g, st[k]); });
      q('[data-brc-brand]').value = st.brand || ''; q('[data-brc-brand-more]').hidden = !st.brand;
    }
    function read() {
      st.hCm = st.hUnit === 'ft' ? num(h1.value) * 30.48 + num(h2.value) * 2.54 : num(h1.value);
      st.wKg = st.wUnit === 'st' ? num(w1.value) * 6.35029 + num(w2.value) * 0.453592 : st.wUnit === 'lb' ? num(w1.value) * 0.453592 : num(w1.value);
      st.brand = q('[data-brc-brand]').value;
      return { h: st.hCm, w: st.wKg, gender: st.gender, build: st.build, pref: st.pref, brand: st.brand, bsize: st.bsize, bfit: st.bfit };
    }
    applyUnits(); fillFromProfile();

    // ---------- controls ----------
    drawer.addEventListener('click', function (e) {
      var u = e.target.closest('[data-brc-unit] button');
      if (u) { var which = u.parentElement.dataset.brcUnit; read(); if (which === 'h') st.hUnit = u.dataset.u; else st.wUnit = u.dataset.u; applyUnits(); fillFromProfile(); return; }
      var o = e.target.closest('[data-brc-opt] [data-v]');
      if (o) { var key = o.parentElement.dataset.brcOpt; st[key] = o.dataset.v; setPressed(o.parentElement, o.dataset.v); return; }
      var t = e.target.closest('[data-brc-sa-tab]');
      if (t) { tab(t.dataset.brcSaTab); return; }
      var n = e.target.closest('[data-brc-next]');
      if (n) {
        if (n.dataset.brcNext === '2' && !n.hasAttribute('data-skip')) { var r = read(); var err = q('[data-brc-sa-err1]'); err.hidden = r.h > 120 && r.w > 30; if (!err.hidden) return; }
        step(n.dataset.brcNext); return;
      }
      if (e.target.closest('[data-brc-calc]')) { calc(); return; }
      if (e.target.closest('[data-brc-res-pick]')) { if (last) { selectSize(root, last.best.size); window.BRC && BRC.closeDrawer(drawer); } return; }
      var cu = e.target.closest('[data-brc-chart-unit] button');
      if (cu) { setPressed(cu.parentElement, cu.dataset.u); renderChart(cu.dataset.u); return; }
    });
    q('[data-brc-brand]').addEventListener('change', function (e) { q('[data-brc-brand-more]').hidden = !e.target.value; st.brand = e.target.value; });

    function step(nr) {
      drawer.querySelectorAll('[data-step]').forEach(function (s) { s.hidden = s.dataset.step !== String(nr); });
      drawer.querySelectorAll('.brc-sa-progress i').forEach(function (i, idx) { i.classList.toggle('on', idx < Math.min(3, Number(nr))); });
      var body = drawer.querySelector('.brc-drawer__body'); if (body) body.scrollTop = 0;
    }
    function tab(name) {
      drawer.querySelectorAll('[data-brc-sa-tab]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.brcSaTab === name)); });
      drawer.querySelectorAll('[data-brc-sa-pane]').forEach(function (p) { p.hidden = p.dataset.brcSaPane !== name; });
      if (name === 'chart') renderChart((q('[data-brc-chart-unit] [aria-pressed="true"]') || {}).dataset ? q('[data-brc-chart-unit] [aria-pressed="true"]').dataset.u : 'cm');
    }

    function calc() {
      var p = read();
      var r = recommend(data, p);
      var err = q('[data-brc-sa-err3]');
      if (!r) { err.hidden = false; return; }
      err.hidden = true; last = r;
      var z = r.best.size;
      q('[data-brc-res-size]').textContent = z; q('[data-brc-res-size2]').textContent = z;
      var room = r.best.garment != null ? Math.round(r.best.garment - r.body) : null;
      var feel = room == null ? '' : room < 10 ? 'a close fit' : room < 18 ? 'a regular fit with easy room' : room < 26 ? 'the relaxed, slightly oversized look it is cut for' : 'a big, boxy oversized fit';
      q('[data-brc-res-why]').innerHTML = room == null
        ? 'Based on your answers, <b>' + z + '</b> is your closest match.'
        : '<b>' + z + '</b> measures ' + Math.round(r.best.garment) + ' cm around the ' + r.dim.toLowerCase() + '. That leaves about <b>' + room + ' cm of room</b> on you, which gives ' + feel + '.';
      var bars = q('[data-brc-res-bars]');
      bars.innerHTML = room == null ? '' : ['fitted', 'regular', 'oversized'].map(function (k) {
        var t = EASE[r.kind][r.cut][k], on = (st.pref || 'regular') === k;
        return '<div class="brc-sa-bar"><span>' + (k.charAt(0).toUpperCase() + k.slice(1)) + '</span><span class="brc-sa-bar__track"><span class="brc-sa-bar__fill" style="width:' + Math.min(100, (t / 34) * 100) + '%;' + (on ? '' : 'opacity:.25') + '"></span></span><span>' + t + ' cm</span></div>';
      }).join('');
      var alt = r.alt;
      q('[data-brc-res-alt]').textContent = alt ? (alt.dir > r.best.dir ? 'Want more room? Go ' + alt.size + '.' : 'Want it closer to the body? Go ' + alt.size + '.') + (st.hCm >= 190 && r.kind === 'top' ? ' You\'re tall, so ' + alt.size + ' also adds length.' : '') : '';
      prof.profile = st; prof[r.kind] = z; save(prof);
      showMine(z);
      step(4);
    }

    function renderChart(unit) {
      var box = q('[data-brc-chart]');
      if (!data.chart) { box.innerHTML = '<p class="brc-sa-note" style="padding:14px">Measurements for this piece are coming soon. Use the size finder, or message us and we will measure it for you.</p>'; return; }
      var rows = Object.keys(data.chart), mine = last ? last.best.size : (prof[data.kind] || '');
      var f = unit === 'in' ? function (v) { return (v / 2.54).toFixed(1); } : function (v) { return typeof v === 'number' ? (v % 1 ? v.toFixed(1) : v) : v; };
      var html = '<table class="brc-sa-table"><thead><tr><th>' + unit + '</th>' + data.sizes.map(function (z) { return '<th class="' + (norm(z) === norm(mine) ? 'is-mine' : '') + '">' + z + '</th>'; }).join('') + '</tr></thead><tbody>';
      rows.forEach(function (r) {
        html += '<tr><td>' + r + (/chest|bust|waist|hip/i.test(r) ? ' (flat)' : '') + '</td>' + data.sizes.map(function (z) { var v = data.chart[r][z]; if (v == null) v = data.chart[r][norm(z)]; return '<td class="' + (norm(z) === norm(mine) ? 'is-mine' : '') + '">' + (v == null ? '–' : f(v)) + '</td>'; }).join('') + '</tr>';
      });
      box.innerHTML = html + '</tbody></table>';
    }

    // ---------- "Your size" chip from saved profile ----------
    var mine = root.querySelector('[data-brc-sa-mine]');
    function showMine(z) {
      if (!z) return;
      root.querySelector('[data-brc-sa-mine-size]').textContent = z;
      mine.classList.add('is-on'); mine.dataset.size = z;
    }
    if (prof.profile) {
      var auto = recommend(data, { h: prof.profile.hCm, w: prof.profile.wKg, gender: data.gender || prof.profile.gender, build: prof.profile.build, pref: prof.profile.pref, brand: prof.profile.brand, bsize: prof.profile.bsize, bfit: prof.profile.bfit });
      if (auto) { last = auto; showMine(auto.best.size); }
    }
    root.querySelector('[data-brc-sa-pick]').addEventListener('click', function () { selectSize(root, mine.dataset.size); });

    // ---------- open ----------
    root.querySelectorAll('[data-brc-sa-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        tab(b.dataset.brcSaOpen === 'chart' ? 'chart' : 'finder');
        if (b.dataset.brcSaOpen !== 'chart') step(last && prof.profile ? 1 : 1);
        if (window.BRC && BRC.openDrawer) BRC.openDrawer(drawer); else drawer.classList.add('is-open', 'is-shown');
      });
    });
  }

  function boot() { document.querySelectorAll('[data-brc-sa]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
